import React, { useState } from "react";
import Tooltip from "antd/lib/tooltip";
import Line_chart from "../../../../../assets/chartIcons/Line_chart.svg";
import area_chart from "../../../../../assets/chartIcons/area_chart.svg";
import Table from "../../../../../assets/chartIcons/Table.svg";
import Bar_chart from "../../../../../assets/chartIcons/Bar_chart.svg";
import countIcon from "../../../../../assets/chartIcons/countIcon.svg";
import verticalBar from "../../../../../assets/chartIcons/verticalBar.svg";
import {
  setWidgetList,
  setAllSelectedCheckbox,
  setIsSelected,
  setUpdateWidgetGraphType,
  setupdatedGraphData,
} from "../../../../../redux/actions/widget/widget";
import { useDispatch, useSelector } from "react-redux";
import { setFooterValue } from "../../../../../redux/actions/section/section";
import uuid from "react-uuid";
import isEqual from "react-fast-compare";

const AwaWidgetHeader = ({
  id,
  type,
  graph_type,
  section_index,
  span,
  widget_index,
  widget_name,
  datatype,
  stacked,
  desc,
  allData,
  sections,
  splitcolumns,
  widHeaderLoader,
  widgetData,
}) => {
  const dispatch = useDispatch();
  const widgetList = useSelector((state) => state.Widget.widgetList);
  const allSelectedCheckbox = useSelector(
    (state) => state.Widget.allSelectedCheckbox
  );
  const isSelected = useSelector((state) => state.Widget.isSelected);
  const [activeTab, setActiveTab] = useState(
    graph_type === "aggregate" ? "verticalbar" : graph_type
  );
  const graphDetail = useSelector((state) => state.Welcome.graphDetail);
  const graphResponse = useSelector((state) => state.apiCall.graphResponse);
  const updatedGraphData = useSelector(
    (state) => state.Widget.updatedGraphData
  );
  const footerValue = useSelector((state) => state.Section.footerValue);
  const Section = useSelector((state) => state.Section.addSection);
  const handleChecklist = (e, value, id1) => {
    let arrList = [...widgetList];
    let select = isSelected;
    let updateGraph =
      updatedGraphData[`${graph_type}_${id}`] &&
      updatedGraphData[`${graph_type}_${id}`]?.selected_chart;
    let updateFooter = { ...footerValue };
    updateFooter.widgetMaker = false;
    dispatch(setFooterValue(updateFooter));
    if (value && e.target.id == id1) {
      select[id] = value;
      dispatch(setIsSelected(select));
      //if checked and id matches then add widget
      let obj = {
        widget_name: widget_name,
        type: type,
        graph_type: updateGraph ? updateGraph : graph_type,
        is_custom: false,
        primary: graphDetail?.first,
        secondary: graphDetail?.second,
        splits: graphDetail?.split,
        filters: graphDetail?.filter,
        datatype: datatype,
        base: graphDetail?.base,
        id: id,
        data: allData?.data,
        percentData: allData?.percent ? allData?.data : null,
        span: span,
        stacked: stacked,
        description: desc,
        x_label: allData?.x_label,
        y_label: allData?.y_label,
        graph_duration: graphDetail?.duration,
        graph_brands: graphDetail?.brands,
        differential: allData?.differential,
        percent: allData?.percent,
        widget_id: uuid(),
        log:
          graphDetail?.aiLogScale !== null
            ? graphDetail?.aiLogScale
            : allData?.log,
      };
      if (arrList?.length > 0 && footerValue?.replaceThisWidget) {
        arrList?.pop();
      }

      arrList?.push(obj);
      dispatch(setWidgetList(arrList));
    } else if (!value) {
      select[id] = value;
      dispatch(setIsSelected(select));
      //if unchecked and id matches then remove widget
      arrList = widgetList?.filter((el) => {
        return el.id !== id;
      });

      dispatch(setWidgetList(arrList));
    }
    if (
      allSelectedCheckbox &&
      graphResponse?.result?.length > arrList?.length
    ) {
      dispatch(setAllSelectedCheckbox(false));
    }
  };

  const handleCharts = (e, id) => {
    if (splitcolumns) {
      let obj = { ...updatedGraphData };
      for (let i = 0; i < splitcolumns; i++) {
        let type = `${graph_type}_${id}${i}`;
        obj[type] = { selected_chart: e, widgetId: id };
      }
      dispatch(setupdatedGraphData(obj));
      let index = widgetList?.findIndex((el) => el?.id === id);
      if (index >= 0) {
        dispatch(setUpdateWidgetGraphType(e, index, widgetList));
      }
    } else {
      let obj = { ...updatedGraphData };
      let type = `${graph_type}_${id}`;
      obj[type] = { selected_chart: e, widgetId: id };

      dispatch(setupdatedGraphData(obj));
      let index = widgetList?.findIndex((el) => el?.id === id);
      if (index >= 0) {
        dispatch(setUpdateWidgetGraphType(e, index, widgetList));
      }
    }

    setActiveTab(e);
  };
  return (
    <>
      {
        <div
          className={`p-10 border-bottom border-color d-flex justify-content-between align-items-center ${
            widHeaderLoader ? " disable" : ""
          }`}
          style={{ minHeight: "5.1rem" }}
        >
          <div className="portlet__title d-flex align-items-center fontSize-16 font-weight500">
            <span
              className={`checklist ${
                widgetList &&
                widgetList?.findIndex((el) => el.id === id) >= 0 &&
                isSelected[id]
                  ? "active"
                  : ""
              }`}
              id={id}
              onClick={(e) => handleChecklist(e, !isSelected[id], id)}
            >
              {widgetList && widgetList?.findIndex((el) => el.id === id) + 1}
            </span>
            {widget_name}{" "}
            {((Section &&
              Section?.[section_index ? section_index : 0]?.data?.[widget_index]
                ?.type === "predefined") ||
              (sections &&
                sections?.[section_index ? section_index : 0]?.widgets?.[
                  widget_index
                ]?.type === "predefined") ||
              widgetData?.type === "predefined") && (
              <Tooltip title="This is a predefined widget and does not support mention level filters">
                <i
                  className="fa fa-info-circle cursor-pointer ml-1"
                  style={{ color: "#A020F0" }}
                />
              </Tooltip>
            )}
          </div>

          <div className="ChartType">
            {graph_type === "aggregate" ? (
              <>
                <img
                  src={countIcon}
                  alt="Count chart"
                  className="mr-2 d-none ChartType-list active"
                />
                <div
                  style={{
                    width: "0.1rem",
                    height: "2.6rem",
                    borderLeft: "0.1rem #ddd dashed",
                  }}
                  className="d-none"
                />
                <Tooltip title="Vertical Bar Chart" placement="bottom">
                  <img
                    src={verticalBar}
                    alt="Vertical Bar chart"
                    className={`mr-1 d-none ml-2 ChartType-list ${
                      activeTab === "verticalbar" && "active"
                    }`}
                    onClick={() => handleCharts("verticalbar", id)}
                  />
                </Tooltip>
                <Tooltip title="Table chart" placement="bottom">
                  <img
                    src={Table}
                    alt="Table chart"
                    className={`mr-1 d-none ChartType-list ${
                      activeTab === "table" && "active"
                    }`}
                    onClick={() => handleCharts("table", id)}
                  />
                </Tooltip>
              </>
            ) : graph_type === "heatmap" ||
              graph_type === "bubble" ||
              graph_type === "sunburst" ||
              graph_type === "wordcloud" ||
              graph_type === "pie" ||
              graph_type === "map" ? (
              ""
            ) : (
              <>
                {graph_type !== "pie" && (
                  <Tooltip title="Line Chart" placement="bottom">
                    <img
                      src={Line_chart}
                      alt="Line chart"
                      className={`mr-1 ChartType-list ${
                        activeTab === "line" && "active"
                      } ${allData?.percent && "d-none"} `}
                      onClick={() => handleCharts("line", id)}
                    />
                  </Tooltip>
                )}
                {graph_type !== "pie" && (
                  <Tooltip title="Area chart" placement="bottom">
                    <img
                      src={area_chart}
                      alt="area chart"
                      className={`mr-1  ChartType-list ${
                        activeTab === "area" && "active"
                      } ${allData?.percent && "d-none"}`}
                      onClick={() => handleCharts("area", id)}
                    />
                  </Tooltip>
                )}
                <Tooltip title="Table Chart" placement="bottom">
                  <img
                    src={Table}
                    alt="Table chart"
                    className={`mr-1 d-none ChartType-list ${
                      activeTab === "table" && "active"
                    }`}
                    onClick={() => handleCharts("table", id)}
                  />
                </Tooltip>
                {graph_type === "pie" ? (
                  ""
                ) : (
                  <Tooltip title="Bar Chart" placement="bottom">
                    <img
                      src={Bar_chart}
                      alt="Bar chart"
                      className={`mr-1 ChartType-list ${
                        activeTab === "bar" && "active"
                      } ${allData?.percent && "d-none"}`}
                      onClick={() => handleCharts("bar", id)}
                    />
                  </Tooltip>
                )}
                {/* {graph_type !== "pie" && (
									<Tooltip title="Line Chart" placement="bottom">
										<img
											src={Line_chart}
											alt="Line chart"
											className={`mr-1 ChartType-list ${
												activeTab === "line" && "active"
											} ${allData?.percent && "d-none"} `}
											onClick={() => handleCharts("line", id)}
										/>
									</Tooltip>
								)} */}
                {/* 
								{(graphDetail?.first && graphDetail?.second) ||
								graphDetail?.first === "CreatedDate" ||
								graphDetail?.first === "Hour" ||
								graphDetail?.first === "Month" ||
								graphDetail?.first === "Weekday" ||
								graph_type === "bar" ? (
									""
								) : (
									<Tooltip title="Pie Chart" placement="bottom">
										<img
											src={speedometer_chart}
											alt="Pie chart"
											className={`ChartType-list ${
												activeTab === "pie" && "active"
											}`}
											onClick={() => handleCharts("pie", id)}
										/>
									</Tooltip>
								)} */}
              </>
            )}
          </div>
        </div>
      }
    </>
  );
};

export default React.memo(AwaWidgetHeader, isEqual);
